import { validationMixin } from "vuelidate";
import { maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "set-new-password",
    mixins: [validationMixin],
    data() {
        return {
            validationErrors: {},
            payload: {
                password: "",
                password_confirmation: "",
                code: this.$route.query.code,
                email: this.$route.query.email,
                _method: "patch",
            },
            showPassword: false,
            showRepeatPassword: false,
        };
    },
    validations: {
        payload: {
            password: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(50),
            },
            password_confirmation: {
                required,
                sameAsPassword: sameAs("password"),
            },
        },
    },
    computed: {
        passwordErrors() {
            let error = [];
            if (!this.$v.payload.password.$dirty) {
                return error;
            }
            if (!this.$v.payload.password.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.password.minLength) {
                error.push(
                    this.$t("minLengthField")
                        .replace(":field", this.$t("passwordField"))
                        .replace(":count", 10)
                );
            }
            if (!this.$v.payload.password.maxLength) {
                error.push(
                    this.$t("maxLengthField")
                        .replace(":field", this.$t("passwordField"))
                        .replace(":count", 50)
                );
            }
            if (this.validationErrors.password) {
                this.validationErrors.password.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        passwordConfirmationErrors() {
            let error = [];
            if (!this.$v.payload.password_confirmation.$dirty) {
                return error;
            }
            if (!this.$v.payload.password_confirmation.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.password_confirmation.sameAsPassword) {
                error.push(this.$t("validationSameAs"));
            }
            if (this.validationErrors.password_confirmation) {
                this.validationErrors.password_confirmation.forEach((row) => {
                    error.push(row);
                });
            }

            return error;
        },

        disableButton() {
            if (
                this.payload.password !== "" &&
                this.payload.password_confirmation !== ""
            ) {
                return false;
            } else {
                return true;
            }
        },
        ...mapGetters({
            loading: "auth/loadingSetPassword",
        }),
    },
    methods: {
        ...mapActions({
            setPassword: "auth/AUTH_SET_NEW_PASSWORD",
        }),
        resetForm() {
            this.$v.$reset();
            this.payload.password = "";
            this.payload.password_confirmation = "";
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.setPassword(this.payload)
                    .then(() => {
                        this.$toasted.success(this.$t("successChangeProfilePassword"));
                        this.$router.push({ name: "sing-in" });

                        this.resetForm();
                    })
                    .catch((error) => {
                        if (error.response.status === 422) {
                            this.$toasted.error(error.response.data.message);
                            this.validationErrors = error.response.data.errors;
                        }
                    });
            }
        },
    },
};
